import { useFetchStaffsAllData } from "../../../apis/staffApis";
import SelectInput from "../../../components/Select";

type Props = {
  register: any;
  errors: any;
  clearErrors?: any;
  setValue?: (name: string, value: any) => void;
  getIds?: any;
  watch?: any;
  control?: any;
  driverData?: any;
  setSelectedDocument?: any;
  pickup?: any;
};

const AssignReceiverLineHaulManifestModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  watch,
  pickup
}: Props) => {

  const { data: staffData } = useFetchStaffsAllData(pickup?.toWarehouseId ?? "");

  return (
      <div className="relative group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 border border-[#D2D2D2]/70 p-2.5 transition-all duration-300 space-y-1.5">
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <div className="w-full space-y-4">
        <SelectInput
          className="w-full"
          name="staffId"
          label="Select Staff"
          placeholder=""
          selectOptions={
            staffData?.map((supervisor: any) => ({
              id: supervisor.id,
              value: supervisor.id,
              text: supervisor.name,
            })) || []
          }
          clearErrors={clearErrors}
          register={register}
          validation={{ required: "Staff is required" }}
          error={errors.staffId}
          disabled={!staffData || staffData.length === 0}
          value={watch("staffId")}
          setValue={(val: string) => {
            setValue?.("staffId", val);
          }}
        />
      </div>
    </div>
  );
};

export default AssignReceiverLineHaulManifestModal;
